export default function getQuantityOfWarehouseCode (inventory, warehouseCode) {
  return inventory.reduce((quantity, warehouse) => {
    if (warehouse.warehouseCode === warehouseCode) {
      return warehouse.quantity
    }
    return quantity
  }, 0)
}
